import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { ApiVisa, BaseApiTemplateService, Core2Config } from "../../shared";




@Injectable({
    providedIn: 'root'
})
export class FiItemWithGlCodeFileHelperService extends BaseApiTemplateService<any> {

    //https://api.akaun.cloud/core2/tnt/dm/erp/fi/fi-items/import-file-helper/with-company-gl-code

    readonly url = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + 'fi/fi-items/import-file-helper/with-company-gl-code'

    constructor(http: HttpClient) {
        super();
        this.apiUrl = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + 'fi/fi-items/import-file-helper/with-company-gl-code';
        this.endpoint_path = Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + 'fi/fi-items/import-file-helper/with-company-gl-code';
        this.httpClient = http;
    }

}
